/** PURE_IMPORTS_START .._operator_merge PURE_IMPORTS_END */
import { mergeStatic } from '../operator/merge';
export var merge = mergeStatic;
//# sourceMappingURL=merge.js.map 



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/rxjs/_esm5/observable/merge.js
// module id = ../../../../rxjs/_esm5/observable/merge.js
// module chunks = vendor